import Vue from 'vue'
import VueRouter from 'vue-router'
import VadiMain from '../views/VadiMain.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'VadiMain',
    //component: VadiMain
    component: () => import(/* webpackChunkName: "about" */ '../views/VadiMain.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
